export default __webpack_public_path__ + "locales/zh-CN/JavascriptSdk.json?hash=458dccc9b217e09449df3fea5ef6dcd8";